import DefaultActionManager from "./default_action_manager";

export const GET_MARKERS_BY_EPISODE = "GET_MARKERS_BY_EPISODE";
export const FETCH_RECENT_MARKERS = "FETCH_RECENT_MARKERS";
export const FETCH_RECENT_AUDIO_BLOCKS = "FETCH_RECENT_AUDIO_BLOCKS";
export const AUDIO_BLOCK_CREATE = "AUDIO_BLOCK_CREATE";
export const AUDIO_BLOCK_UPDATE = "AUDIO_BLOCK_UPDATE";
export const AUDIO_BLOCK_GET_FOR_USER = "AUDIO_BLOCK_GET_FOR_USER";
export const AUDIO_BLOCK_GET = "AUDIO_BLOCK_GET";
export const AUDIO_BLOCK_DELETE = "AUDIO_BLOCK_DELETE";
export const MARKERS_UPDATE = "MARKERS_UPDATE";
export const GET_MARKERS_PAGE = "GET_MARKERS_PAGE";

export const audioBlockCreate = (name, playStyle, limit, items) =>
  new DefaultActionManager({
    method: "POST",
    actionName: AUDIO_BLOCK_CREATE,
    auth: true,
    route: "audio-blocks",
    body: {
      name,
      playStyle,
      limit,
      items,
    },
    successMessage: "Audio Block Created",
  }).run();

export const audioBlockUpdate = (uuid, name, playStyle, limit, items) =>
  new DefaultActionManager({
    method: "POST",
    actionName: AUDIO_BLOCK_UPDATE,
    auth: true,
    route: `audio-blocks/${uuid}`,
    body: {
      name,
      playStyle,
      limit,
      items,
    },
    successMessage: "Audio Block Updated",
  }).run();

export const getAudioBlocksForUser = user =>
  new DefaultActionManager({
    actionName: AUDIO_BLOCK_GET_FOR_USER,
    auth: true,
    route: `users/${user.uuid}/audio-blocks`,
  }).run();

export const getAudioBlock = uuid =>
  new DefaultActionManager({
    actionName: AUDIO_BLOCK_GET,
    auth: true,
    route: `audio-blocks/${uuid}`,
    actionData: {
      uuid,
    },
  }).run();

export const fetchRecentMarkers = () =>
  new DefaultActionManager({
    actionName: FETCH_RECENT_MARKERS,
    auth: true,
    route: `markers/recent?limit=10`,
  }).run();

export const getMarkersByEpisodeUUID = episodeUUID =>
  new DefaultActionManager({
    actionName: GET_MARKERS_BY_EPISODE,
    auth: true,
    route: `episodes/${episodeUUID}/markers`,
    method: "get",
    actionData: { episodeUUID },
  }).run();

export const updateMarkers = markers =>
  new DefaultActionManager({
    actionName: MARKERS_UPDATE,
    auth: true,
    route: `markers`,
    method: "POST",
    body: markers,
    successMessage: "Insertion points updated",
  }).run();

export const fetchRecentAudioBlocks = userUUID =>
  new DefaultActionManager({
    actionName: FETCH_RECENT_AUDIO_BLOCKS,
    auth: true,
    route: `users/${userUUID}/audio-blocks?limit=10`,
    method: "get",
  }).run();

export const deleteAudioBlock = uuid =>
  new DefaultActionManager({
    actionName: AUDIO_BLOCK_DELETE,
    auth: true,
    route: `audio-blocks/${uuid}`,
    method: "DELETE",
    actionData: { uuid },
    successMessage: "Audio block deleted",
  }).run();

export const getMarkersPage = () =>
  new DefaultActionManager({
    actionName: GET_MARKERS_PAGE,
    auth: true,
    route: `markers/recent?limit=50`,
  }).run();
